// components/Header.tsx - Header Component
import React from 'react';
import { Users, Shield } from 'lucide-react';
import { UserRole, Transaction } from '../types';

interface HeaderProps {
  userRole: UserRole;
  setUserRole: (role: UserRole) => void;
  transactions: Transaction[];
}

const Header: React.FC<HeaderProps> = ({ userRole, setUserRole, transactions }) => {
  const totalCollection = transactions.reduce((sum, t) => sum + t.amount, 0);

  return (
    <header className="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-40">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center shadow-lg">
              <Users className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Waste Management</h1>
              <p className="text-sm text-gray-500">
                {userRole === 'admin' ? 'Admin Dashboard' : 'Fee Collection Portal'}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setUserRole(userRole === 'admin' ? 'collector' : 'admin')}
              className="flex items-center space-x-2 px-3 py-2 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors"
            >
              <Shield className="w-4 h-4" />
              <span className="text-sm font-medium">
                {userRole === 'admin' ? 'Admin' : 'Collector'}
              </span>
            </button>
            <div className="text-right">
              <div className="text-xs text-gray-500">Total Collection</div>
              <div className="text-lg font-bold text-green-600">
                ₹{totalCollection.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;